import React from "react";
import Page from "../Components/Page";
import {Breadcrumbs} from "../Components/Breadcrumbs";
import PropTypes from "prop-types";
import AirflowDagLogs from "../Components/airflow/dagLogs/AirflowDagLogs";

export const ProcessingLogsPage = ({retailerId = undefined, displayHelmetHeader = true}) => {
    return (
        <Page name={'Processing Logs'} displayHelmetHeader={displayHelmetHeader}
              breadCrumbs={<Breadcrumbs items={[{label: 'Logs'}, {label: 'Processing Logs'}]}/>}>
            <AirflowDagLogs
                retailerId={retailerId}
                includeDagName={true}
                includeRetailer={true}
                customColumns={[
                    {header: 'Until Date', accessorKey: 'fillenddate', className: 'non-numeric-field'}
                ]}
            />
        </Page>
    )
}

ProcessingLogsPage.propTypes = {
    retailerId: PropTypes.number,
    displayHelmetHeader: PropTypes.bool
};